import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SharedService } from 'src/app/services/shared.service';

export interface ChatButton {
  id: string;
	name: string;
  description: string;
}

export interface ChatMessage {
  role: string;
	content: string;
	description?: string;
	buttons?: ChatButton[];
	intervals?: [];
	full_intervals_list?: any[];
	continue?: ChatButton[];
  timestamp: string;
	loading?: boolean;
}

@Component({
    selector: 'app-conv-chat-bot',
    templateUrl: './conv-chat-bot.component.html',
    styleUrl: './conv-chat-bot.component.scss',
    standalone: false
})
export class ConvChatBotComponent implements OnInit, AfterViewInit {
	@ViewChild('scrollRef') scrollRef: any;
	
	@Input() url_service!: any;
	@Output() jumpToTime = new EventEmitter<number>();

	pchat = 'assets/images/logo/logo-only.png';

	loading = false;
	spinner = false;
	success = false;
	submitted = false;

	chat_lang = 'en';

	chatMessagesData: ChatMessage[] = [];
	sub_intervals_show = false;
	selected_index: number | null = null;
	

	constructor(private sharedService: SharedService) { }
	
	ngOnInit(): void {
		this.loading = true;
		this.sharedService.initialChatBotElbit(this.url_service.chatBotElbit).subscribe({
			next: (data: any) => {
				this.chatMessagesData = data.conversationHistory;
				this.loading = false;
				this.submitted = false;
				this.onListScroll();
			},
			error: () => {
				this.loading = false;
				this.submitted = false;
			}
		});
	}

	ngAfterViewInit(): void {
		this.onListScroll();
	}

	onListScroll() {
		setTimeout(() => {
			this.scrollRef.SimpleBar.getScrollElement().scrollTop = this.scrollRef.SimpleBar.getScrollElement().scrollHeight;
		}, 500);
	}

	changeChatLang() {
		switch (this.chat_lang) {
			case 'he':
				this.chat_lang = 'en';
				break;
			case 'en':
				this.chat_lang = 'he';
				break;
			default:
				this.chat_lang = 'en';
				break;
		}
	}

	handleButtonClick(selectedButton: ChatButton) {
		this.submitted = true;

		const message = {
			role: 'user',
			content: selectedButton.name,
			description: selectedButton.description,
			timestamp: new Date().toISOString()
		};

		this.chatMessagesData.push(message);
		this.onListScroll();

		this.chatMessagesData.push({
			role: 'assistant',
      content: '', // Initially empty
      timestamp: new Date().toISOString(),
      loading: true 
		});

		this.sharedService.chatBotAnswerElbit(this.url_service.chatBotElbit, { message: message, question: selectedButton }).subscribe({
			next: (data: any) => {
				this.chatMessagesData[this.chatMessagesData.length-1] = data.answer;

				this.onListScroll();
				this.loading = false;
				this.submitted = false;
			},
			error: () => {
				this.loading = false;
				this.submitted = false;
			}
		});
	}

	onTimestampClick(time: number, index: number | null) {
		this.selected_index = index;
    this.jumpToTime.emit(time+1);
  }

	sub_text_rename(text: string) {
		switch (text) {
			case 'blinks_below_the_avg':
				return 'Engagement';
			case 'blinks_difference':
				return 'Engagement';
			case 'eye_exceeding_intervals':
				return 'Eye Leaks';
			case 'eyebrow_exceeding_intervals':
				return 'EyeBrow Leaks';
			case 'high_cognitive_event':
				return 'Cognitive';
			case 'high_emotion_event':
				return 'Emotion';
			case 'high_cognitive_above_th':
				return 'Cognitive';
			case 'high_emotion_above_th':
				return 'Emotion';
			case 'high_cognitive_emotion_above_th':
				return 'Cog & Emo';
			case 'high_cognitive_emotion_cross':
				return 'Skin Trend';
			case 'high_cognitive_emotion_cross_with_th':
				return 'Skin Trend +';
			default:
				return '';
		}
	}

	onTimestampClickSub(time: number) {
    this.jumpToTime.emit(time+1);
  }

	convertToTimerFormat(seconds: number) {
		if (seconds < 3600) {
			// Display "mm:ss" format for the first 60 minutes
			const minutes = Math.floor(seconds / 60);
			const formattedSeconds = (seconds % 60).toString().padStart(2, "0");
			const formattedMinutes = minutes.toString().padStart(2, "0");
			return `${formattedMinutes}:${formattedSeconds}`;
		} else {
			// After 60 minutes, switch to "hh:mm:ss" format
			const hours = Math.floor(seconds / 3600);
			const remainingSeconds = seconds % 3600;
			const minutes = Math.floor(remainingSeconds / 60);
			const formattedSeconds = (remainingSeconds % 60).toString().padStart(2, "0");
			const formattedMinutes = minutes.toString().padStart(2, "0");
			const formattedHours = hours.toString().padStart(2, "0");
			return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
		}
	}
}
